import { Component, OnInit } from '@angular/core';
import { AppserviceService } from 'src/app/appservice.service';
import { NgxSpinnerService } from 'ngx-spinner';
import {NgbAlertConfig} from '@ng-bootstrap/ng-bootstrap';
import * as myGlobals from 'src/app/globals';

@Component({
  selector: 'app-abandon',
  templateUrl: './abandon.component.html',
  styleUrls: ['./abandon.component.sass']
})
export class AbandonComponent implements OnInit {
  AppData$;
  dataSource = [];
  dataSourceParts = [];
  woPartsData = [];
  consignmentNo:string;
  abandonItem:boolean = false;
  abandonItemData = [];
  recipient:string;
  abandonRecSearchData =[];
  newRecData = [];
  abandonRecipient:string = '';
  abandonQuantity = 1;
  consignmentCode:string;
  dataErrorSearch:boolean = false;
  showAbandonParts:boolean = false;
  selectedItem = '';
  selectedPartItem = '';
  abandonpartObj:{} = {
    "part_code": "",
    "consignment_code": "",
    "from_store": "",
    "to_store": "",
    "from_bin": "",
    "qty": "",
    "quick_in": 1,
    "i_clear_reservations": 0,
    "wo_id": "",
    "to_bin": "",
    "i_create_reservations":1,
    "courierno":null
  };
  recipientArr:Array<Object> = [
    // {value: 'ENG', name: "Engineer"},
    {value: 'RSL', name: "RSL"}
  ];

  abandonUpdateBool:boolean = false;
  abandonUpdateMsg = "";
  abandonUpclass = "";

  constructor(private AppService:AppserviceService,private alertConfig: NgbAlertConfig, private spinner:NgxSpinnerService) { 
    this.newRecData = this.abandonRecSearchData = this.AppService.getRslData();
  }

  refreshView() {
    const usrname = localStorage.getItem('username')
    this.spinner.show();
    this.AppService.fetchAbandonWos(usrname).subscribe((dataObj : any[]) =>{
      // this.spinner.hide();
      console.log(dataObj);
      this.dataSource = dataObj['data'];

      if(dataObj['data'].length > 0){
        this.AppService.fetchAbandonParts(usrname).subscribe((abandonData) => {
          //console.log(abandonData['data'].length);
          this.spinner.hide();
          this.dataSourceParts = abandonData['data'];
        });
      }else{
        this.dataSource = null;
        this.spinner.hide();
      }
    },
    (err) => {
      this.spinner.hide();
    });
  }

  abandonItemFn(item){
    //console.log(item, this.consignmentCode);
    this.selectedPartItem = item;
    this.abandonItem = true;
    this.abandonItemData = item;
    this.abandonpartObj['from_bin'] = item.bis_bin;
    this.abandonpartObj['to_bin'] = 'GOODSIN';
    this.abandonpartObj['from_store'] = item.bis_store;
    this.abandonpartObj['part_code'] = item.bis_part;
    this.abandonpartObj['qty'] = 1; //this.abandonQuantity = item.bis_qty;
  }

  itemData(event, dataObj, index){
    //console.log(dataObj, index,dataObj.wo+index);
    this.selectedItem = dataObj;
    this.showAbandonParts = true;
    //document.getElementById(dataObj.wo+index).className = 'list-group-item list-group-item-action active';
    this.woPartsData = dataObj;
    console.log(this.woPartsData);
    this.consignmentNo = "Enter consignment number for part " + dataObj.part_id;
  }
  selectedRecipient(selrec){
    // console.log(selrec);
    //this.abandonpartObj['to_bin'] = this.abandonpartObj['from_bin'];
    this.abandonpartObj['to_store'] = selrec.name;
    this.abandonRecipient = selrec;
  }

  selectRecipient(recepnt){
    console.log(recepnt);
    var _sV = recepnt.target.value.toUpperCase();
    this.newRecData = Object.assign([], this.abandonRecSearchData).filter(item => {
      if(item['name'].indexOf(_sV) > -1){
        return item;
      }
    });
  }

  searchRecipient(recipientval){
    //console.log(recipientval);
    this.newRecData = this.abandonRecSearchData = (recipientval.target.value === 'Engineer')? this.AppService.getEngData() : this.AppService.getRslData();
    if(this.newRecData != null){
      this.dataErrorSearch = false;
    }else{
      this.dataErrorSearch = true;
      this.alertConfig.type = 'success';
      this.alertConfig.dismissible = false;
    }
  }

  abandonpart(){
    this.abandonpartObj['consignment_code'] = this.consignmentCode;
    this.abandonpartObj['wo_id'] = this.woPartsData['rwo_wo'];//this.dataSource[0]['rwo_wo'];
    this.abandonpartObj['engineer'] = this.dataSource[0]['rwo_engineer'];
    this.abandonpartObj['from_store'] = localStorage.getItem('username');
    this.abandonpartObj['quick_in'] = 1;
    this.abandonpartObj['courierno'] = '';
    console.log(this.abandonpartObj);
    this.spinner.show();
    this.AppService.issueParts(this.abandonpartObj).subscribe((dataObj : any[])=> {
      this.spinner.hide();
      console.log('success');
      this.abandonItem = false;
      this.showAbandonParts = false;
      this.abandonUpdateBool = true;
      this.newRecData = [];
      this.abandonUpdateMsg = "Part " + this.abandonpartObj['part_code'] + "with Work order no " + this.abandonpartObj['wo_id'] + " successfull abandoned.";
      this.abandonUpclass = myGlobals.appMessages['classes']['success'];
      this.refreshView();
    },
    (err) => {
      this.spinner.hide();
      this.abandonUpdateBool = true;
      this.abandonUpdateMsg = "Error in abandoning the part!";
      this.abandonUpclass = myGlobals.appMessages['classes']['error'];
    });
  }

  ngOnInit() {
    this.refreshView();
  }

}
